export default class SessionStorageAdapter {
  static isSupported() {
    try {
      window.sessionStorage.setItem('adapter-check', 'adapter-check');
      window.sessionStorage.removeItem('adapter-check');
      return true;
    } catch(e) {
      return false;
    }
  }

  static setItem(key, value) {
    if (this.isSupported()) {
      window.sessionStorage.setItem(key, value);
    }
  }

  static getItem(key) {
    if (this.isSupported()) {
      return window.sessionStorage.getItem(key);
    }
  }
}
